import { createStore, combineReducers, applyMiddleware, AnyAction } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk, ThunkMiddleware } from 'redux-thunk';
import notificationReducer from './reducers/notificationReducer';
import userReducer from './reducers/userReducer';
import postReducer from './reducers/postReducer';
import exploreReducer from './reducers/exploreReducer';
import herdReducer from './reducers/herdReducer';
import postCommentsReducer from './reducers/postCommentsReducer';
import userPageReducer from './reducers/userPageReducer';
import herdPageReducer from './reducers/herdPageReducer';
import searchReducer from './reducers/searchReducer';
import themeReducer from './reducers/themeReducer';
import glassReducer from './reducers/glassReducer';
import achievementReducer from './reducers/achievementReducer';
import activityReducer from './reducers/activityReducer';
import economyReducer from './reducers/economyReducer';
import cosmeticsReducer from './reducers/cosmeticsReducer';
import storageService from './utils/localStorage';
import directMessagesReducer from './reducers/directMessagesReducer';

const reducer = combineReducers({
  user: userReducer,
  notification: notificationReducer,
  posts: postReducer,
  explore: exploreReducer,
  postComments: postCommentsReducer,
  herds: herdReducer,
  userPage: userPageReducer,
  herdPage: herdPageReducer,
  search: searchReducer,
  themePreference: themeReducer,
  glassSettings: glassReducer,
  achievements: achievementReducer,
  activity: activityReducer,
  economy: economyReducer,
  cosmetics: cosmeticsReducer,
  directMessages: directMessagesReducer,
});

export type RootState = ReturnType<typeof reducer>;

// Preload theme from storage so first paint uses correct mode (avoids flash + extra work)
const preloadedState: Partial<RootState> = {
  themePreference: storageService.loadThemePreferenceLocal(),
  glassSettings: storageService.loadGlassSettingsLocal(),
};

const store = createStore(
  reducer,
  preloadedState,
  composeWithDevTools(applyMiddleware(thunk as ThunkMiddleware<RootState, AnyAction, unknown>))
);

export type AppDispatch = typeof store.dispatch;

export default store;
